import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, ReferenceLine } from 'recharts';
import { CustomTooltip } from './CustomTooltip';

interface RoutineBarChartProps {
  weekDays: any[];
}

export const RoutineBarChart = ({ weekDays }: RoutineBarChartProps) => {
  return (
    <div className="h-[200px] -mx-2 sm:-mx-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={weekDays} margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
          <defs>
            <pattern id="barPattern" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
              <rect width="8" height="8" fill="#FFFFFF" fillOpacity="0.8"/>
              <rect width="4" height="8" fill="#000000" fillOpacity="1"/>
            </pattern>
          </defs>
          <XAxis 
            dataKey="name" 
            axisLine={false}
            tickLine={false}
            tick={{ fill: 'currentColor', fontSize: 12 }}
            className="text-foreground dark:text-white/80"
          />
          <YAxis hide={true} domain={[0, 'auto']} />
          <Tooltip 
            content={<CustomTooltip />}
            cursor={{ fill: 'rgba(51, 195, 240, 0.05)' }}
          />
          {weekDays.map((day, index) => (
            !day.isRestDay && (
              <ReferenceLine 
                key={`goal-${index}`}
                y={day.goal} 
                stroke="currentColor" 
                strokeOpacity={0.2}
                strokeDasharray="3 3"
                strokeWidth={2}
                segment={[{ x: index - 0.45, y: day.goal }, { x: index + 0.45, y: day.goal }]}
              />
            )
          ))}
          <Bar 
            dataKey="count" 
            fill="url(#barPattern)"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};